// extracted by mini-css-extract-plugin
export default {"melodyVideo":"HN-z","isFullWidth":"IN-z","landingPageVideo":"JN-z","play":"KN-z","iframeVideo":"LN-z","playHidden":"MN-z","fullwidth":"NN-z"};